import { Loader2 } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

/**
 * Motion is reduced rather than removed under `prefers-reduced-motion`: a
 * frozen spinner reads as a hung page, which is the opposite of reassuring.
 */
export function Spinner({ className, ...props }: ComponentProps<typeof Loader2>) {
  return (
    <Loader2
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn('size-5 animate-spin motion-reduce:[animation-duration:3s]', className)}
      {...props}
    />
  );
}
